import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "rootElement",
  class: "d-flex flex-column justify-content-between h-100"
}
const _hoisted_2 = { class: "row row-name mb-2" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row row-settings mb-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "row align-items-center pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_10 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_visibility_rule = _resolveComponent("visibility-rule")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (!_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.pageUI.getIsReady())
        ? (_openBlock(), _createBlock(_component_dp_form, {
            key: 0,
            as: "form",
            onSubmit: _ctx.submitData,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_visibility_rule, {
                        payload: _ctx.visibilityRule,
                        visibilityRuleOptionsKeys: _ctx.visibilityRuleOptionsKeys,
                        "hide-delete": "",
                        errors: errors,
                        onChanged: _ctx.onVisibilityRuleChanged
                      }, null, 8, ["payload", "visibilityRuleOptionsKeys", "errors", "onChanged"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t('save')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_base_offcanvas_button_close, {
                      ref: "closeButton",
                      class: "btn btn-light"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true)
    ], 512)
  ], 64))
}